// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 生产环境中注释掉以下语句
import 'sysStatic/css/theme-default.scss'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './components/install'
import domain from './service/getData'
import ajax from './service/ajax'
import common from './service/common'
import echarts from 'echarts' //引入echarts

import  {adminRouter,rolloutRouter,rollinRouter} from '@/router/routerTable';




Vue.prototype.$echarts = echarts //引入echarts组件
Vue.prototype.$domain=domain  //全局引入接口路径
Vue.prototype.$ajax=ajax  //全局引入接口路径
Vue.prototype.$common=common  //全局引入接口路径
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  //一旦刷新浏览器就会执行这里
  created(){
    //判断用户是否登录
    // if(common.getStorage('userInfo')){
    //   //组织路由
    //   const Layout = () => import(/* webpackChunkName: 'index' */ './page/layout')
    //   let userInfo=common.getStorage('userInfo');
    //   let newRouter=[{
    //       path: '/personal',
    //       component: () => import(/* webpackChunkName: 'home' */ './page/personal'),
    //   }]
    //   if(userInfo.userRoleList.indexOf('admin')>-1){
    //     newRouter=newRouter.concat(adminRouter);
    //   }
    //   if(userInfo.userRoleList.indexOf('rollout')>-1){
    //     newRouter=newRouter.concat(rolloutRouter);
    //   }
    //   if(userInfo.userRoleList.indexOf('rollin')>-1){
    //     newRouter=newRouter.concat(rollinRouter);
    //   }
    //   if(userInfo.userRoleList.indexOf('statistics')>-1){
    //     newRouter=newRouter.concat(stateRouter);
    //   }
    //   let endRouter=[
    //     {
    //       path: '/home',
    //       component: Layout,
    //       children: newRouter
    //     },{
    //       path:'/404',
    //       name:'404',
    //       component: () => import(/* webpackChunkName: 'home' */ './page/error/index'),
    //     }
    //   ];
    //   this.$router.addRoutes(endRouter);
    // }else{
    //   this.$router.repalce('/login')
    // }
    
  }
})



// WEBPACK FOOTER //
// ./src/main.js